import { Injectable } from '@angular/core';

export interface LeadCollectorPrefillData {
  token: string;
  firstname?: string;
  lastname?: string;
  phoneNumber?: string;
  email?: string;
  city?: string;
}

@Injectable({ providedIn: 'root' })
export class LeadCollectorPrefillService {
  private data: LeadCollectorPrefillData | null = null;

  set(data: LeadCollectorPrefillData): void {
    this.data = data;
  }

  get(): LeadCollectorPrefillData | null {
    return this.data;
  }

  clear(): void {
    this.data = null;
  }

  hasPrefill(): boolean {
    return this.data !== null;
  }
}

